import React, { useState, useRef, useEffect } from "react";
import { ImageGalleryProps } from "../../types/interface";
import blankImage from "../../assets/icons/inference.svg";
import { useTest } from "./TestContext";
import downloadButton from "../../assets/icons/download.svg";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { downloadTest } from "../../store/slice/ProjectTestSlice";
import { LinearProgress, ListItem, List } from "@mui/material";
import { AxiosProgressEvent } from "axios";
import { toast } from "react-toastify";
//import testImage from "../../assets/img/image-test.jpg";

export interface LabelDetail {
  labelName: string;
  count: number;
}

const Blank: React.FC<ImageGalleryProps> = ({ id }) => {
  const { firstResult, model, compare, sliderValue } = useTest();
  const [progress, setProgress] = useState<number>(0);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const [labelDetails, setLabelDetails] = useState<LabelDetail[]>([]);

  
  const handleDownloadImage = (base64Image: string) => {
    const link = document.createElement("a");
    link.href = `data:image/jpeg;base64,${base64Image}`; // Change the image type if needed (jpeg, png, etc.)
    link.download = "image.jpg"; // The file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = async (trainingId: string) => {
    setIsDownloading(true);
    setProgress(0);

    const resultAction = await dispatch(
      downloadTest({
        trainingId,
        options: {
          onDownloadProgress: (progressEvent: AxiosProgressEvent) => {
            // Specify the type here
            const total = progressEvent.total || 0;
            const current = progressEvent.loaded || 0;
            const percentage = Math.floor((current / total) * 100);
            setProgress(percentage);
          },
        },
      })
    );

    setIsDownloading(false);

    if (downloadTest.fulfilled.match(resultAction)) {
      // const { duration } = resultAction.payload;
      toast.success(`Download completed`, {
        position: "bottom-right",
      });
    } else {
      toast.error(resultAction.error.message as string, {
        position: "bottom-right",
      });
    }
  };

  const ImagePopup = ({
    imageSrc,
    onClose,
  }: {
    imageSrc: string;
    onClose: () => void;
  }) => {
    const [zoomLevel, setZoomLevel] = useState(1);
    const [initialZoom, setInitialZoom] = useState(1);
    const [dragging, setDragging] = useState(false);
    const [dragStart, setDragStart] = useState<{ x: number; y: number } | null>(
      null
    );
    const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });

    const containerRef = useRef<HTMLDivElement | null>(null);
    const imageRef = useRef<HTMLImageElement | null>(null);

    // Ensure image fits within screen on load
    useEffect(() => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        if (containerRef.current) {
          const { clientWidth, clientHeight } = containerRef.current;
          const scale = Math.min(
            clientWidth / image.width,
            clientHeight / image.height,
            1
          );
          setZoomLevel(scale);
          setInitialZoom(scale); // Store for resetting
        }
      };
    }, [imageSrc]);

    // Handle zooming
    const handleWheel = (event: React.WheelEvent) => {
      event.preventDefault();
      if (event.deltaY < 0) {
        setZoomLevel((prevZoom) => Math.min(prevZoom + 0.1, 3)); // Zoom in
      } else {
        setZoomLevel((prevZoom) => Math.max(prevZoom - 0.1, initialZoom)); // Zoom out but not below fit
      }
    };

    // Handle dragging with left-click only
    const handleMouseDown = (event: React.MouseEvent) => {
      if (event.button !== 0) return;
      setDragging(true);
      setDragStart({
        x: event.clientX - imagePosition.x,
        y: event.clientY - imagePosition.y,
      });
    };

    const handleMouseMove = (event: React.MouseEvent) => {
      if (!dragging || !dragStart) return;
      requestAnimationFrame(() => {
        setImagePosition({
          x: event.clientX - dragStart.x,
          y: event.clientY - dragStart.y,
        });
      });
    };

    const handleMouseUp = () => setDragging(false);

    // Reset to fit size
    const handleReset = () => {
      setZoomLevel(initialZoom);
      setImagePosition({ x: 0, y: 0 });
    };

    console.log(firstResult?.labelInfo);
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        {/* Image Container */}
        <div
          ref={containerRef}
          onWheel={handleWheel}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          style={{
            position: "relative",
            overflow: "hidden",
            width: "90vw",
            height: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: dragging ? "grabbing" : "grab",
          }}
        >
          <img
            ref={imageRef}
            src={imageSrc}
            alt="Zoomed"
            style={{
              transform: `scale(${zoomLevel}) translate(${imagePosition.x}px, ${imagePosition.y}px)`,
              transformOrigin: "center center",
              transition: dragging ? "none" : "transform 0.2s ease",
              maxWidth: "none",
              maxHeight: "none",
              userSelect: "none",
              pointerEvents: "none",
            }}
          />
        </div>

        {/* Controls */}
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            display: "flex",
            justifyContent: "center",
            gap: "15px",
          }}
        >
          {/* Zoom In */}
          <button
            onClick={() => setZoomLevel((prev) => Math.min(prev + 0.1, 3))}
            style={buttonStyle}
          >
            +
          </button>

          {/* Zoom Out (only down to fit screen) */}
          <button
            onClick={() =>
              setZoomLevel((prev) => Math.max(prev - 0.1, initialZoom))
            }
            style={buttonStyle}
          >
            -
          </button>

          {/* Reset (Fit to Screen) */}
          <button onClick={handleReset} style={buttonStyle}>
            Fit
          </button>

          {/* Close */}
          <button onClick={onClose} style={buttonStyle}>
            ✖
          </button>
        </div>
      </div>
    );
  };

  // Reusable button styles
  const buttonStyle: React.CSSProperties = {
    width: "35px",
    height: "35px",
    background: "#fff",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const openPopup = (imageSrc: string) => {
    setSelectedImage(imageSrc);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };

  return (
    <>
      {isDownloading && (
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            backgroundColor: "#e0e0e0", // Background color for the track
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#4caf50", // Green color for the progress bar
            },
          }}
        />
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          overflow: "scroll",
          minHeight: compare ? "calc(100vh - 300px)" : "calc(100vh - 240px)",
          maxHeight: compare ? "calc(100vh - 300px)" : "calc(100vh - 240px)",
          position: "relative", // Added for absolute positioning of the download button
          backgroundColor: isDownloading ? "lightgrey" : "transparent", // Light grey background if downloading
        }}
      >
        {labelDetails.length > 0 ? (
          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "60px",
              padding: "10px",
              backgroundColor: "#838983", // Green background for the button
              border: "none", // No border
              borderRadius: "5px", // Rounded corners
              cursor: "pointer",
              display: "flex",
              alignItems: "center", // Center vertically
              justifyContent: "center", // Center horizontally
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <button
              style={{ background: "none", border: "none", color: "white" }}
            >
              Label
            </button>

            {isHovered && (
              <List
                sx={{
                  position: "absolute",
                  top: "40px",
                  right: "0",
                  backgroundColor: "#fff",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  width: "max-content",
                  zIndex: 1000,
                }}
              >
                {labelDetails &&
                  labelDetails.map((label: any, index) => (
                    <ListItem
                      key={index} // ✅ Always use a unique key when mapping
                      sx={{
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#f0f0f0" },
                      }}
                    >
                      {/* <span
                  style={{
                    width: "18px",
                    height: "18px",
                    background: labelDetails.color,
                    borderRadius: "3px",
                    display: "inline-block",
                  }}
                ></span> */}
                      {label.labelName} ({label.count})
                    </ListItem>
                  ))}
              </List>
            )}
          </div>
        ) : (
          ""
        )}
        {isDownloading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent overlay
              zIndex: 1, // Ensure overlay is above other content
              pointerEvents: "all", // Block pointer events
            }}
          />
        )}


        {/* Download button */}

        {firstResult && model && sliderValue ? (
          <>
            <iframe src={firstResult?.data?.InferenceLink}  title="Inference Viewer"
        width="100%"
        height="100%"
        style={{ 
          display: "block",
          border: "none",
          minHeight: compare ? "calc(100vh - 320px)" : "calc(100vh - 260px)",
          maxHeight: compare ? "calc(100vh - 320px)" : "calc(100vh - 260px)",
         }}></iframe>
          </>
        ) : (
          <>
            <img src={blankImage} alt="blanks" style={{ maxWidth: "100%" }} />
          </>
        )}
      </div>


    </>
  );
};

export default Blank;
